import { makeStyles } from '@fluentui/react'

export const usePersonalAccountMeterReadingsStyles = makeStyles(() => ({
  table: {
    width: '100%',
    marginBottom: '8px',
  },
}))
